import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import Register from "./register/Register";
import Sad from "./shared/Sad";
import Layout from "./layout/Layout";
import TopNav from "./dashboard/TopNav";
import LeftNav from "./dashboard/LeftNav";
import { ShowRankingsLayout } from "./rankings/show/show-rankings-layout";
import { ShowRankingsAppleMonths, loadShowRankingsAppleMonths } from "./rankings/show/show-rankings-apple-months";
import { ShowRankingsApple } from "./rankings/show/show-rankings-apple";

export const AppRoutes = <Route>
    <Route path="/dashboard/*" element={<Dashboard />} />
    <Route path="/register/*" element={<Register />} />
    <Route path="*" element={<Sad />} />
</Route>;

//export const appRoutesExperiments = queryClient => (
//    <Route path="/*" element={<AppLayout />}>
//        <Route element={<RootLayout />}>
//            <Route index element={<Root />} loader={rootLoader(queryClient)} />
//        </Route>
//        <Route path=":accountID/*" element={<DashboardLayout />} loader={servicesListLoader(queryClient)}>
//            <Route index element={<ServicesList />} />
//            <Route path="measurement/*" lazy={async () => {
//                const { MeasurementDashboard: Component } = await import("./measurement");
//                return {
//                    Component
//                };
//            }} />
//        </Route>
//        <Route path=":accountID/layout" element={<LayoutTest />} />
//        <Route path="dashboard/*" lazy={async () => {
//            const { default: Component } = await import("./dashboard/Dashboard");
//            return {
//                Component
//            };
//        }} />
//        {/*<Route path="/dashboard/new/*" lazy={() => import("./NewRoutes")} />
//            <Route path="/dashboard/test/:accountID" lazy={() => import("./key-metrics/KeyTest")} />
//            <Route path="/dashboard/test" Component={NewLayout} />
//            <Route path="*" lazy={async () => {
//                const { default: Component } = await import("./AppRoutes");
//                return {
//                    Component
//                };
//            }} />*/}
//    </Route>
//);
